module.exports = __webpack_public_path__ + "assets/img/bg.1b5dee49.png";